module.exports = __webpack_public_path__ + "static/img/banner.8692083.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mesuggestions/banner.png
// module id = Q9Sf
// module chunks = 44